<template>
  <addService :service="service" :loading="loading" />
</template>
<script>
import addService from '@/pages/service/add'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { currency } from '@/mixins/currency'
import { getAService } from '@/api/services'
export default {
  mixins: [gregorianToJalali, currency],
  data() {
    return {
      service: null,
      loading: true,
    }
  },
  components: {
    addService,
  },
  created() {
    getAService.api(this.$route.params.id).then((res) => {
      this.service = {
        ...res,
        id: this.$route.params.id,
        date: this.gregorianToJalali(res.date),
        next_date: this.gregorianToJalali(res.next_date),
        price: this.currency(res.price),
        disabled: this.$route.name.includes('VIEW') ? true : false,
        approvers: res.approvers.map((approver) => approver.user.id),
        meter_interval:
          res.meter_interval !== 0 ? res.meter_interval / 1000 : 0,
        meter_threshold:
          res.meter_threshold !== 0 ? res.meter_threshold / 1000 : 0,
        odometer: res.odometer !== 0 ? res.odometer / 1000 : 0,
        company_vehicle: res.company_vehicle.id,
        service: res.service.id,
      }
      this.loading = false
    })
  },
}
</script>
